import { useRef, useState } from 'react';

export const useRegisterPage = () => {
  const captchaRef = useRef(null);

  const [isVerified, setIsVerified] = useState(false);
  const [isLoginLoading, setIsLoginLoading] = useState(false);

  const handleFormSubmit = (event) => {
    setIsLoginLoading(true);

    event.preventDefault();
    event.persist();

    setIsLoginLoading(false);
  };

  const recaptchaLoaded = (response) => {
    if (response) {
      setIsVerified(true);
    }
  };

  const recaptchaExpired = () => {
    setIsVerified(false);
  };

  return {
    captchaRef,
    handleFormSubmit,
    isLoginLoading,
    isVerified,
    recaptchaExpired,
    recaptchaLoaded
  };
};
